import React, {useState} from 'react';
import js_beautify from "js-beautify";

export interface HoverProps {
    children: React.ReactNode;
    hoverChildren: React.ReactNode;
}

const Hover: React.FC<HoverProps> = ({children, hoverChildren}) => {
    const [hover, setHover] = React.useState(false);

    return (
        <div className="folio-container" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <div className="folio-body">
                {children}
                <div className={`folio-hover folio-hover-${hover ? 'shown' : 'hidden'}`}>
                    {hoverChildren}
                </div>
            </div>
        </div>
    );
};


export interface InspectHoverProps {
    children: React.ReactNode
}

export const InspectHover: React.FC<InspectHoverProps> = ({children}) => {
    const [ref, setRef] = useState<HTMLDivElement|null>(null);
    const createInsectHover = () => {
        const width = ref?.offsetWidth ?? 0;
        console.log(width)
        const innerHtml: string = js_beautify(ref?.innerHTML ?? '', {
            "indent_size": 4,
            "indent_char": " ",
            "max_preserve_newlines": 5,
            "preserve_newlines": true,
            "keep_array_indentation": false,
            "break_chained_methods": false,
            // "indent_scripts": "normal",
            "brace_style": "collapse",
            "space_before_conditional": true,
            "unescape_strings": false,
            "jslint_happy": false,
            "end_with_newline": false,
            "wrap_line_length": width,
            // "indent_inner_html": false,
            "comma_first": false,
            "e4x": false,
            "indent_empty_lines": false
        })
        return (
            <pre>
                {innerHtml}
            </pre>
        );
    }

    return (
        <Hover hoverChildren={createInsectHover()}>
            <div ref={newRef => setRef(newRef)}>
                {children}
            </div>
        </Hover>
    );
};


export default Hover;